module.exports = "pegasus_template/assets/tech/welcome/100.png";